<div *ngIf="isLoading">
  <po-loading-overlay p-text="Carregando" p-size="sm"></po-loading-overlay>
</div>

<app-toaster></app-toaster>

<div class="po-wrapper">
  <po-page-default>
    <div class="row po-font-text-small po-mb-3">
      <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="breadcrumbActiveIndex" (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
    </div>

    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <p class="po-font-title">Consulta Preço</p>
    </div>

    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <app-scanner (scannedData)="onScannedData($event)"></app-scanner>
      </div>
    </div>

    <div *ngIf="searched && product" class="result-section po-pl-2 po-pr-2">
      <div class="product-card">
        <h3 class="card-title">Detalhes do produto</h3>

        <div class="product-detail-row">
          <div class="product-image-wrapper">
            <img *ngIf="product.imageUrl" [src]="product.imageUrl" alt="Imagem do produto" class="product-image" />
            <div *ngIf="!product.imageUrl" class="no-image">
              <i class="an an-image-broken no-image-icon"></i>
              <span class="no-image-label">Sem imagem</span>
            </div>
          </div>

          <div class="product-info">
            <p class="product-name">{{ product.name }}</p>
            <p class="product-meta"><b>Código:</b> {{ product.code }}<span *ngIf="product.sku"> &nbsp;|&nbsp; <b>SKU:</b> {{ product.sku }}</span></p>
            <p class="product-meta">
              <b>Cor:</b> {{ product.color }} - <b>Tam:</b> {{ product.size }}
            </p>

            <div class="table-wrapper">
              <div class="table-scroll">
                <table class="price-table">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Descrição</th>
                      <th class="text-right">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of product.prices">
                      <td>{{ row.tipo }}</td>
                      <td>{{ row.descricao }}</td>
                      <td class="text-right">{{ row.valorUnit | currency:'BRL':'symbol':'1.2-2' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="po-pb-5 po-mb-5"></div>

  </po-page-default>
</div>
